import AvailabilityApi from '../api/AvailabilityApi';
import AvailabilityDetailConstants from '../constants/AvailabilityDetailConstants';

function openAvailability(metadataId) {
  return {
    metadataId,
    type: AvailabilityDetailConstants.OPEN_AVAILABILITY_DETAILS
  };
}

function closeAvailability() {
  return {
    type: AvailabilityDetailConstants.CLOSE_AVAILABILITY_DETAILS
  };
}

function getAvailability(id) {
  return {
    types: [
      AvailabilityDetailConstants.AVAILABILITY_DETAIL_REQUEST,
      AvailabilityDetailConstants.AVAILABILITY_DETAIL_SUCCESS,
      AvailabilityDetailConstants.AVAILABILITY_DETAIL_ERROR
    ],
    apiRequest: (state, client) => AvailabilityApi.fetchResults(id, client)
  };
}

function getDigitalAvailability(id) {
  return {
    types: [
      AvailabilityDetailConstants.DIGITAL_AVAILABILITY_REQUEST,
      AvailabilityDetailConstants.DIGITAL_AVAILABILITY_SUCCESS,
      AvailabilityDetailConstants.DIGITAL_AVAILABILITY_ERROR
    ],
    apiRequest: (state, client) => AvailabilityApi.fetchResults(id, client)
  };
}

function getHoldingsProbes(id) {
  return {
    types: [
      AvailabilityDetailConstants.HOLDINGS_PROBE_REQUEST,
      AvailabilityDetailConstants.HOLDINGS_PROBE_SUCCESS,
      AvailabilityDetailConstants.HOLDINGS_PROBE_ERROR
    ],
    apiRequest: (state, client) => AvailabilityApi.fetchHoldingsProbes(id, client)
  };
}

export default {
  openAvailability,
  closeAvailability,
  getAvailability,
  getDigitalAvailability,
  getHoldingsProbes
};
